import { css, jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import React from 'react';

import Heading from '@/src/shared/components/Heading';
import Icon from '@/src/shared/components/Icon';
import Link from '@/src/shared/components/Link';
import { bp, colors } from '@/styles';

const style = {
  card: css`
    max-width: 368px;
    border-radius: 2px;
    background-color: #fff;
    padding: 18px;
    box-shadow: 0 6px 12px 0 rgba(35, 32, 32, 0.1);
    margin: 16px;
    flex: 1 0 368px;
    @media ${bp.sm} {
      padding: 28px;
    }
  `,
  header: css`
    display: flex;
    align-items: center;
    margin-bottom: 24px;
  `,
  icon: css`
    font-size: 5.6rem;
    width: 56px;
    margin-right: 12px;
    color: ${colors.secondaryBlue};
  `,
  link: css`
    display: block;
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
  `,
};

function StateLinksCard(props) {
  const { iconId, category, links, stateCode } = props;

  return (
    <section css={style.card}>
      <header css={style.header}>
        <Icon id={iconId} css={style.icon} />
        <div>
          <Heading type={5} theme="gray" weight="bolder">
            Category
          </Heading>
          <Heading type={4} weight="bolder" theme="primaryBlue">
            {category}
          </Heading>
        </div>
      </header>
      <div>
        {links.map(link => (
          <Link
            href={link.href}
            as={link.as || link.href.replace('[slug]', stateCode)}
            css={style.link}
            anchor={link.external}
            target={link.external ? '_blank' : '_self'}
            key={link.title}
          >
            {link.title}
          </Link>
        ))}
      </div>
    </section>
  );
}

StateLinksCard.propTypes = {
  category: PropTypes.string.isRequired,
  iconId: PropTypes.number.isRequired,
  links: PropTypes.array.isRequired,
  stateCode: PropTypes.string,
};

StateLinksCard.defaultProps = {
  stateCode: '',
};

export default StateLinksCard;
